import React from "react"

const NotFound = () => <>Not Found</>

export default NotFound
